import React from "react";

const NeuroViewModal = ({
  isOpen,
  onClose = () => {},
}) => {
  const dummyQuestions = [
    {
      question: 'How satisfied are you with the teaching quality?',
      options: ['Very Satisfied', 'Satisfied', 'Neutral', 'Dissatisfied'],
      selectedOption: 'Very Satisfied',
      image: 'https://img.freepik.com/free-photo/morskie-oko-tatry_1204-510.jpg?t=st=1745425452~exp=1745429052~hmac=ade1de76495e045cab9e4d573f8b12506ae7d5a185835eb78105fc7ebceb0fa7&w=996'
    },
    {
      question: 'How would you rate the school facilities?',
      options: ['Excellent', 'Good', 'Fair', 'Poor'],
      selectedOption: 'Good',
      image: 'https://img.freepik.com/free-photo/morskie-oko-tatry_1204-510.jpg?t=st=1745425452~exp=1745429052~hmac=ade1de76495e045cab9e4d573f8b12506ae7d5a185835eb78105fc7ebceb0fa7&w=996'
    },
    {
      question: 'Do you feel the curriculum meets your needs?',
      options: ['Strongly Agree', 'Agree', 'Disagree', 'Strongly Disagree'],
      selectedOption: 'Agree',
      image: 'https://img.freepik.com/free-photo/morskie-oko-tatry_1204-510.jpg?t=st=1745425452~exp=1745429052~hmac=ade1de76495e045cab9e4d573f8b12506ae7d5a185835eb78105fc7ebceb0fa7&w=996'
    }
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white w-3/4 max-h-[80vh] overflow-y-auto rounded-lg shadow-lg p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold">
            Survey Questions
          </h2>
        </div>

        <div className="space-y-6">
          {dummyQuestions.map((questionObj, qIndex) => (
            <div key={qIndex} className="relative border border-gray-200 p-4 rounded flex gap-4">
              <div className="w-2/6 h-[200px]" >
                <img 
                  src={questionObj.image} 
                  alt={`Question ${qIndex + 1}`}
                  className="w-full h-100 rounded"
                />
              </div>
              <div className="w-8/12">
                <div className="flex justify-between items-start mb-2">
                  <label className="block font-medium">
                    Question {qIndex + 1}
                  </label>
                </div>
                <div>
                  <p className="w-full p-2 rounded">
                    {questionObj.question}
                  </p>
                </div>
                
                <div className="grid grid-cols-2 gap-4 mt-3">
                  {questionObj.options.map((option, oIndex) => (
                    <div 
                      key={oIndex} 
                      className={`border border-gray-200 p-2 rounded ${option === questionObj.selectedOption ? 'bg-[#241763] text-white' : ''}`}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
  
          <div className="flex justify-end space-x-4 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-400 text-white px-6 py-2 rounded hover:bg-gray-500"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NeuroViewModal;